import { Appointment } from 'fhir/r4';

export type StatusType =
  | 'proposed'
  | 'confirmed'
  | 'pending'
  | 'booked'
  | 'arrived'
  | 'fulfilled'
  | 'cancelled'
  | 'noshow'
  | 'entered-in-error'
  | 'checked-in'
  | 'waitlist';
export type InfoType = 'payment' | 'connection' | 'link' | 'text' | 'markdown';

export interface AdditionalInformation {
  description: string;
  title: string;
  type: InfoType;
  value: string;
}
export interface AppointmentInterface extends Omit<Appointment, 'status'> {
  status: StatusType;
  additionalInformation?: AdditionalInformation[];
}
export interface AppointmentStateInterface {
  list: AppointmentInterface[];
  history: AppointmentInterface[];
}

function state(): AppointmentStateInterface {
  return {
    list: [],
    history: []
  };
}

export default state;
